import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/cosborn_text.png'
import _imports_1 from '../assets/red_arrow.png'
import _imports_2 from '@/assets/connections/youtube.svg'
import _imports_3 from '@/assets/connections/insta.svg'


const _withScopeId = n => (_pushScopeId("data-v-67d4f4ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home-content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"home-logo\" data-v-67d4f4ea><div class=\"home-logo-wrapper\" alt=\"cosborn logo\" data-v-67d4f4ea><img class=\"home-logo-img rotating1\" src=\"/assets/cosborn_logo_c.png\" data-v-67d4f4ea><img class=\"home-logo-img-nose floating\" src=\"/assets/cosborn_logo_nose.png\" data-v-67d4f4ea><img class=\"home-logo-img rotating2\" src=\"/assets/cosborn_logo_o.png\" data-v-67d4f4ea><img class=\"home-logo-img floating-less\" src=\"/assets/cosborn_logo_pupils.png\" data-v-67d4f4ea><img class=\"home-logo-img floating-less\" src=\"/assets/cosborn_logo_mouth.png\" data-v-67d4f4ea></div></div><img class=\"cosborn-name-img\" alt=\"cosborn text\" src=\"" + _imports_0 + "\" data-v-67d4f4ea>", 2)
const _hoisted_5 = { class: "home-splash-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "click-me" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "click-me-arrow",
    src: _imports_1,
    width: "16",
    height: "16"
  }),
  /*#__PURE__*/_createTextVNode(" click me ")
], -1))
const _hoisted_7 = { class: "link-tiles-container" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"link-big-tiles\" data-v-67d4f4ea><a class=\"link-big-tile\" href=\"https://www.youtube.com/@cosborn\" rel=\"noopener\" target=\"_blank\" data-v-67d4f4ea><img id=\"youtube\" src=\"" + _imports_2 + "\" data-v-67d4f4ea></a><a class=\"link-big-tile\" href=\"https://www.instagram.com/cameron_of_oz\" rel=\"noopener\" target=\"_blank\" data-v-67d4f4ea><img id=\"insta\" src=\"" + _imports_3 + "\" data-v-67d4f4ea></a></div>", 1)

import CustomRouterLink from '@/components/CustomRouterLink.vue'
import LinkTileGrid from '@/components/LinkTileGrid.vue'
import LinkTileInternal from '@/components/LinkTileInternal.vue'
import LinkTileExternal from '@/components/LinkTileExternal.vue'
import { ref } from 'vue'
import linksInternal from '@/assets/linksInternal.json'
import linksExternalSocial from '@/assets/linksExternalSocial.json'
import linksExternalMusic from '@/assets/linksExternalMusic.json'
import splashes from '@/assets/splashes.json'

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const splash = ref<string>('You can\'t see me.')
const nextSplash = ref<string>('')
const specialSplash = ref<boolean>(false)

// const typewriterErase = () => {
//   let i = 0
//   const speed = 50
//   const totalLength = splash.value.length
//   if(i < totalLength) {
//     splash.value = splash.value.slice(0, -1);
//     i++;
//     setTimeout(typewriterErase, speed);
//   }
// }

const newSplash = (): void  => {
  if (specialSplash.value) {
    specialSplash.value = false
  } else {
    specialSplash.value = Math.floor(Math.random() * 200000) === 100199
  }
  do {
    if (specialSplash.value) {
      nextSplash.value = splashes.messages[splashes.messages.length-1]
    } else {
      const splashIndex = Math.floor(Math.random() * (splashes.messages.length-1))
      nextSplash.value = splashes.messages[splashIndex]
    }
  }
  while (splash.value == nextSplash.value)
  splash.value = nextSplash.value
}

newSplash()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["home-splash-text", specialSplash.value? 'special-splash' : '']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (newSplash()))
        }, _toDisplayString(splash.value), 3),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(LinkTileGrid, { cols: 5 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(linksInternal), (item, i) => {
              return (_openBlock(), _createBlock(LinkTileInternal, {
                key: `home-link-internal-${i}`,
                data: item
              }, null, 8, ["data"]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(LinkTileGrid, {
          title: "other places where I exist",
          cols: 7
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(linksExternalSocial), (item, i) => {
              return (_openBlock(), _createBlock(LinkTileExternal, {
                key: `home-link-external-social-${i}`,
                data: item
              }, null, 8, ["data"]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(LinkTileGrid, {
          title: "stream my music anywhere",
          cols: 6
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(linksExternalMusic), (item, i) => {
              return (_openBlock(), _createBlock(LinkTileExternal, {
                key: `home-link-external-music-${i}`,
                data: item
              }, null, 8, ["data"]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})